import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useGetUserBusinessList } from "../../../lib/queries/queriesAndMutations";
import Buttons from "../../Buttons";
import Pagination from "../../Pagination";
import Loader from "../../shared/Loader";
import ImageWithShimmer from "../../ui/ImageWithShimmer";
import BusinessCard from "./BusinessCard";
import BusinessRow from "./BusinessRow";

const BussinessList = () => {
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  const onPageChange = useCallback((page) => setCurrentPage(page), []);

  const { data, isPending, refetch } = useGetUserBusinessList({
    currentPage,
    pageSize,
  });

  useEffect(() => {
    refetch();
  }, [currentPage]);

  if (isPending) {
    return (
      <div className="w-full h-full flex-center">
        <Loader />
      </div>
    );
  }

  return (
    <>
      {data?.count ? (
        <div className="w-full  p-1  overflow-y-scroll vanda  h-full">
          <div className="w-full flex flex-col items-end  p-1 md:p-6 rounded-v-lg">
            <div className="w-full flex justify-between items-center mb-2">
              <div onClick={() => navigate("/business/new")}>
                <Buttons
                  btnStyleparam="mainbutton"
                  fontsize="dashboard"
                  bgcolor="primary"
                  txtcolor="primary"
                  children="کسب وکار جدید"
                  lefticon={false}
                  righticon={false}
                  borders="secondary"
                  bRadius="xl"
                />
              </div>
            </div>

            <div className="w-full mt-4 hidden md:block bg-neutral-00 ">
              <div className="w-full grid grid-cols-[.25fr_1fr_1fr_1fr_1fr_1fr_1fr_1fr]  py-4 whitespace-nowrap text-neutral-40 mt-2 px-4">
                <div className=" text-center">#</div>
                <div className=" text-center">نـام کسب وکار</div>
                <div className=" text-center">نوع کسب وکار</div>
                <div className="text-center">صنف</div>

                <div className="text-center">موجودی</div>

                <div className="text-center">ونداپرداخت</div>
                <div className="text-center">وضعیت</div>
                <div className="text-center">مسدودی</div>
              </div>
              <hr className="bg-neutral-20 w-full h-1 mb-2" />

              <div className="w-full gap-2 p-4 rounded-[16px] grid grid-cols-1   ">
                {data ? (
                  data.items.map((item, index) => (
                    <BusinessRow
                      key={index}
                      isApproved={true}
                      rowData={item}
                      index={index}
                      // handleChangeAccount={handleChangeAccount}
                    />
                  ))
                ) : (
                  <p>آیتمی وجود ندارد ...</p>
                )}
              </div>
            </div>
          </div>
          <div className="w-full space-y-2   md:hidden  p-1 ">
            {data.count ? (
              data.items.map((item, index) => (
                <BusinessCard
                  key={index}
                  isApproved={true}
                  rowData={item}
                  index={index}
                  // handleChangeAccount={handleChangeAccount}
                />
              ))
            ) : (
              <p>آیتمی وجود ندارد ...</p>
            )}
          </div>

          <div className="w-full bg-neutral-10 rounded-v-lg mt-2">
            <Pagination
              onPageChange={onPageChange}
              totalCount={data?.count}
              siblingCount={1}
              currentPage={currentPage}
              pageSize={pageSize}
              className="bg-primary-40"
            />
          </div>
        </div>
      ) : (
        <div className="w-full h-full flex justify-center items-center ">
          <div className="flex flex-col items-center gap-6 p-6 bg-white max-w-[700px]   rounded-xl shadow-md w-fit">
            <ImageWithShimmer src="/images/wellcomepic.svg" />
            <p className="flex justify-center items-center mb-4">
              {" "}
              هنوز کسب وکاری برای شما ایجاد نشده است. برای افزودن اولین کسب وکار، کافی است بر روی دکمه زیر
              کلیک نمایید و ادامه فرایند را طی کنید.
            </p>

            <button className="main-btn w-full " onClick={() => navigate("/business/new/")}>
              افزودن کسب و کار جدید
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default BussinessList;
